var App = App || {};

App.WidgetCallout = (function ($) {
    'use strict';

    function Init(widget) {
        const animate = widget;
        animate.ZagScrollAnimate({
            targets: [
                { selector: ".partial-callout", type: "animate__fadeInUp", stagger: 0 }
            ]
        });
    }

    return {
        Init: Init
    };

})(jQuery);